import React, { useEffect, useRef } from 'react';
import Header from '../components/Header';
import Outlook from '../components/Outlook';
import MainActivities from '../components/Overview';
import OtherActivities from '../components/Events';
import News from '../components/News';
import Join from '../components/Join';
import Contact from '../components/Contact';

function HomePage() {
  const headerRef = useRef(null);
  const outlookRef = useRef(null);
  const isScrolling = useRef(false);

  useEffect(() => {
    const handleScroll = (e) => {
      if (isScrolling.current) return;

      const headerRect = headerRef.current.getBoundingClientRect();

      if (e.deltaY > 0 && headerRect.bottom > 0 && headerRect.bottom <= window.innerHeight) {
        isScrolling.current = true;
        outlookRef.current.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => { isScrolling.current = false; }, 1000);
      }
    };

    window.addEventListener('wheel', handleScroll, { passive: false });

    return () => {
      window.removeEventListener('wheel', handleScroll);
    };
  }, []);

  return (
    <>
      <div ref={headerRef}>
        <Header />
      </div>
      <div ref={outlookRef}>
        <Outlook />
      </div>
      <main>
        <MainActivities />
        <OtherActivities />
        <News />
        <Join />
        <Contact />
      </main>
    </>
  );
}

export default HomePage;
